// @ts-strict

import { Component, EventEmitter, ViewChild } from '@angular/core';
import { IvrConfigurationsService } from '@app/core/services/ivr-configurations/ivr-configurations.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CampaignConfigurationsService } from '@pages/campaigns/campaign-details-view/campaign-configurations/campaign-configurations.service';
import { GlobalNotificationsService } from '@app/core/services/global-notifications/global-notifications.service';
import { NotificationType, NotificationTypes } from '@app/core/services/global-notifications/global-notifications.model';
import { PromotionMethodDescriptionComponent } from './promotion-method-description/promotion-method-description.component';

@Component({
  selector: 'app-add-promotion-method-modal',
  templateUrl: './add-promotion-method-modal.component.html',
  styleUrls: ['./add-promotion-method-modal.component.scss']
})
export class AddPromotionMethodModalComponent {
  @ViewChild(PromotionMethodDescriptionComponent) promotionMethodDescriptionComponent!: PromotionMethodDescriptionComponent;

  public promotionMethodDescription: string = '';
  public promotionMethodURL: string = '';

  public isFormValidated: EventEmitter<boolean> = new EventEmitter();
  public fieldsValues: {
    description: string;
    website: string;
  } = {
    description: '',
    website: ''
  };
  submitted = false;

  constructor(
    public activeModal: NgbActiveModal,
    private readonly ivrServices: IvrConfigurationsService,
    private readonly campaignConfigurationsService: CampaignConfigurationsService,
    private readonly globalNotificationsService: GlobalNotificationsService
  ) {}

  public verifyForm(): void {
    this.submitted = true;
    const promotionDescription = this.promotionMethodDescriptionComponent?.formControls?.promotionMethodDescriptionInput;
    const promotionURL = this.promotionMethodDescriptionComponent?.formControls?.promotionURLInput;
    if (promotionDescription?.value && promotionDescription.valid) {
      if (promotionURL?.value) {
        if (promotionURL.valid) {
          this.sendToService();
        } else {
          this.errorNotification();
        }
      } else {
        this.sendToService();
      }
    } else {
      this.errorNotification();
    }
  }

  private sendToService(): void {
    this.ivrServices.addIVRPromotionMethod(this.fieldsValues).subscribe(res => {
      if (res.status_code === 200) {
        this.showNotification('added_successfully', NotificationTypes[0]);
        this.ivrServices.addPromotionMethod.next(true);
        this.campaignConfigurationsService.promotionMethodAdded.emit();
        this.activeModal.close();
      } else {
        this.showNotification('error_occured', NotificationTypes[1]);
      }
    });
  }

  private showNotification(message: string, type: NotificationType): void {
    this.globalNotificationsService.show({
      message: message.includes('view_translations.') ? message : `view_translations.${message}`,
      type,
      translate: true,
      isPersistent: false,
      id: ''
    });
  }

  private errorNotification(): void {
    this.showNotification('error_occured', NotificationTypes[1]);
  }
}
